import { useCallback, useEffect, useState } from 'react'
import Icon from '@dustin-web/microsite-components/src/icon'
import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { ProductWithCategoryType } from '@dustin-web/product-components/src/utils/digital-data-types'
import Popover from '@dustin-web/microsite-components/src/popover/popover'
import { Spinner } from '@dustin-web/microsite-components/src/spinner'
import { CreateFavoriteListDialog } from './create-favorite-list-dialog'

type Props = {
  className?: string
  productsInCart: ProductWithCategoryType[]
}

const CreateFavoriteListButton = ({ className, productsInCart }: Props) => {
  const { translate } = useI18n()
  const [showDialog, setShowDialog] = useState(false)
  const [loading, setLoading] = useState(false)

  const onPopoverClick = useCallback(() => {
    setShowDialog(true)
  }, [])

  useEffect(() => {
    if (showDialog) {
      setLoading(false)
    }
  }, [showDialog])

  return (
    <>
      <Popover
        positions={['bottom-free']}
        open={showDialog}
        onToggle={x => setShowDialog(x)}
        closeOnOutsideClick={true}
        closeOnEscape={true}
        content={
          <CreateFavoriteListDialog
            productsInCart={productsInCart}
            loading={loading}
            setLoading={() => setLoading(true)}
          />
        }>
        <button
          type="button"
          onClick={onPopoverClick}
          className={`button-stripped u-decoration-none u-mb-0 ${className}`}>
          <Icon name="heart" className="u-mr-8 i-16" />
          <span>{translate('Cart_SaveAsFavoriteList')}</span>
        </button>
      </Popover>
      {loading ? <Spinner dustinSpinner={true} /> : null}
    </>
  )
}

export default CreateFavoriteListButton
